var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmbulance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_767)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.525 23.3499H34.05V20.1407C34.05 19.7637 33.8986 19.4015 33.6314 19.1343L30.6656 16.1685C30.3984 15.9013 30.0362 15.7499 29.6592 15.7499H28.35V14.3249C28.35 13.5382 27.7117 12.8999 26.925 12.8999H17.425C16.6383 12.8999 16 13.5382 16 14.3249V23.8249C16 24.6116 16.6383 25.2499 17.425 25.2499H17.9C17.9 26.8233 19.1766 28.0999 20.75 28.0999C22.3234 28.0999 23.6 26.8233 23.6 25.2499H27.4C27.4 26.8233 28.6766 28.0999 30.25 28.0999C31.8234 28.0999 33.1 26.8233 33.1 25.2499H34.525C34.7862 25.2499 35 25.0362 35 24.7749V23.8249C35 23.5637 34.7862 23.3499 34.525 23.3499ZM20.75 26.6749C19.9633 26.6749 19.325 26.0366 19.325 25.2499C19.325 24.4632 19.9633 23.8249 20.75 23.8249C21.5367 23.8249 22.175 24.4632 22.175 25.2499C22.175 26.0366 21.5367 26.6749 20.75 26.6749ZM25.025 19.3124C25.025 19.443 24.9181 19.5499 24.7875 19.5499H23.125V21.2124C23.125 21.343 23.0181 21.4499 22.8875 21.4499H21.4625C21.3319 21.4499 21.225 21.343 21.225 21.2124V19.5499H19.5625C19.4319 19.5499 19.325 19.443 19.325 19.3124V17.8874C19.325 17.7568 19.4319 17.6499 19.5625 17.6499H21.225V15.9874C21.225 15.8568 21.3319 15.7499 21.4625 15.7499H22.8875C23.0181 15.7499 23.125 15.8568 23.125 15.9874V17.6499H24.7875C24.9181 17.6499 25.025 17.7568 25.025 17.8874V19.3124ZM30.25 26.6749C29.4633 26.6749 28.825 26.0366 28.825 25.2499C28.825 24.4632 29.4633 23.8249 30.25 23.8249C31.0367 23.8249 31.675 24.4632 31.675 25.2499C31.675 26.0366 31.0367 26.6749 30.25 26.6749ZM32.625 20.4999H28.35V17.1749H29.6592L32.625 20.1407V20.4999Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_767",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_767"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/ambulance.c50fdff9bd96892084eafff14e2dbba0.svg";
export { ForwardRef as ReactComponent };